import { TransText } from '@/i18n/trans/text';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons } from '@packages/webshop-design-system';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

interface RefundModalSelectionFooterProps {
  handleClose: () => void;
  handleInitiateRefund: () => void;
  selected: number;
  loading: boolean;
}

const RefundModalSelectionFooter: FC<RefundModalSelectionFooterProps> = ({
  handleClose,
  handleInitiateRefund,
  selected,
  loading,
}) => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <div className="flex gap-2">
      <Button
        variant="tertiary"
        data-testid="cancel-refund-btn"
        onClick={handleClose}
        className="rounded-lg laptop:w-auto"
        size={isLaptopOrBigger ? 'regular' : 'large'}
      >
        <TransText i18nKey="cancel" />
      </Button>
      <Button
        data-testid="continue-refund-btn"
        onClick={handleInitiateRefund}
        isDisabled={!selected}
        isPending={loading}
        className="rounded-lg laptop:w-auto"
        size={isLaptopOrBigger ? 'regular' : 'large'}
        endAdornment={
          <Icons.arrowRight
            height={isLaptopOrBigger ? 16 : 24}
            width={isLaptopOrBigger ? 16 : 24}
          />
        }
      >
        <TransText i18nKey="continue" />
      </Button>
    </div>
  );
};

export default RefundModalSelectionFooter;
